// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"9a85b5e70a39c188","9260":"6d901244f674625a"}[chunkId] + ".js";
};